module.exports = __webpack_public_path__ + "static/img/2.ea1aec4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/sp/2.png
// module id = Sfki
// module chunks = 0